export const getTotalPages = (totalItems, itemsPerPage) =>
  Math.ceil(totalItems / itemsPerPage);

export const getStartIndex = (itemsPerPage, currentPage) =>
  itemsPerPage * currentPage;

export const getEndIndex = (itemsPerPage, currentPage, totalItems) => {
  const endIndex = itemsPerPage * (currentPage + 1);

  return endIndex > totalItems ? totalItems - 1 : endIndex - 1;
};

export const limitPageRange = (totalItems, itemsPerPage) => (currentPage) =>
  Math.min(
    Math.max(currentPage, 0),
    getTotalPages(totalItems, itemsPerPage) - 1
  );

export const getPages = (start, end) =>
  Array.from({ length: end - start + 1 }, (_, index) => index + start);

const getPagination = ({ totalItems, itemsPerPage, currentPage }) => {
  const totalPages = getTotalPages(totalItems, itemsPerPage);

  return {
    totalPages,
    startIndex: getStartIndex(itemsPerPage, currentPage),
    endIndex: getEndIndex(itemsPerPage, currentPage, totalItems),
    pages: getPages(0, totalPages - 1),
  };
};

export default getPagination;
